/*
 * @TagTable.vue
 * @Description 今日进场组件
 * @Author 
 * @Date 
 */
<template>
  <div class="table-item-box _padding-l-none" style="padding: 10px;">
    <section style="height: 100%;">

      <!-- 表格 -->
      <el-table :data="tableInfos"
                ref="tableInfos"
                stripe
                :class="{'table': true, 'no-pagination': false}"
      >
        <el-table-column v-for="(item, index) in colData" :key="index" :label="item.title" v-if="item.isShow" :min-width="item.minWidth">
          <template v-slot="scope">
            <span style="white-space: nowrap;" :title="scope.row[item.value]">{{scope.row[item.value]}}</span>
          </template>
        </el-table-column>
      </el-table>

      <!--分页工具条-->
      <Pagination
          :currentPage="pagination.currentPage"
          :total="pagination.total"
          :pageSize="pagination.limit"
          @handleSizeChangeSub="handleSizeChangeSub"
          @handleCurrentChangeSub="handleCurrentChangeSub"
      />

      <!--查询工具条-->
      <el-col style="text-align: left;">
        <el-form :inline="true" :model="filters" ref="filters">
          <el-form-item>查询条件：</el-form-item>
          <el-form-item prop="status">
            <el-select v-model="filters.status" placeholder="请选择进入状态" clearable @change="research">
              <el-option v-for="(item,key) in status" :key="key" :label="item" :value="key" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="keywords">
            <el-input v-model="filters.keywords" placeholder="请输入人员编号/姓名/手机号" style="width: 400px" clearable @keyup.enter.native="research">
              <i slot="suffix" class="el-input__icon el-icon-search" @click="research"></i>
            </el-input>
          </el-form-item>
        </el-form>
      </el-col>

    </section>
  </div>

</template>

<script>
// 基站组件
import ApiApproach from '@/request/api-approach'
import Pagination from '@/components/Pagination'

export default {
  name: "ApproachToday",
  /**
   * @Des 组件引用
   * @Auth jsh
   * @Date 09:41 2021/6/28
   */
  components: {
    Pagination
  },
  /**
   * @Des 数据定义
   * @Auth jsh
   * @Date 09:41 2021/6/28
   */
  data() {
    return {
      /**
       * @Des 查询条件属性
       * @Auth jsh
       * @Date 09:41 2021/6/28
       */
      filters: {
        keywords: '',
        status: '',
      },
      colData: [
        {title: "编号", value:"idCard", isShow: true, minWidth: '200px'},
        {title: "姓名", value:"userName", isShow: true, minWidth: '110px'},
        {title: "性别", value:"sex", isShow: true, minWidth: '80px'},
        {title: "手机号", value:"phone", isShow: true, minWidth: '130px'},
        {title: "进入时间", value:"inTimeStr", isShow: true, minWidth: '200px'},
        {title: "离开时间", value:"outTimeStr", isShow: true, minWidth: '200px'},
        {title: "进入时长", value:"inDurationStr", isShow: true, minWidth: '150px'},
        {title: "状态", value:"statusName", isShow: true, minWidth: '100px'},
        {title: "绑定类型标签", value:"tag", isShow: true, minWidth: '200px'},
      ],
      colOptions: [], //默认全选
      colSelect: [],
      // 表格信息
      tableInfos:[],
      pagination:{
        total: 0,
        startNum: 0,
        limit: 50,
        currentPage: 1
      },
      status:{
        1: '进入现场',
        2: '离开现场'
      }
    }
  },
  computed: {
  },
  created(){
    this.setDefaultTableTitle();
    this.search();
  },
  mounted(){
  },
  /**
   * @Des 监听
   * @Auth
   * @Date 2021/6/4
   */
  watch: {
    pagination: {
      handler(newVal, oldVal){
        this.search();
      },
      immediate: true,
      deep:true,
    }
  },
  /**
   * @Des 方法定义
   * @Auth jsh
   * @Date 09:42 2021/6/28
   */
  methods: {
    /**
     * 设置默认选中的表头
     * */
    setDefaultTableTitle(){
      this.colOptions = [];
      this.colSelect = [];
      this.colData.forEach((row, index) => {
        this.colOptions.push(row.title);
        this.colSelect.push(row.title);
      })
    },

    /**
     * 重新搜索
     * */
    research(){
      this.pagination.total = 0;
      this.pagination.startNum = 0;
      this.pagination.currentPage = 1;
      this.search();
    },
    /**
     * @Des 查询基站
     * @Auth jsh
     * @Date 09:42 2021/6/28
     */
    search() {
      this.$request.postJsonRequest(ApiApproach.searchInoutApi, {
        projectId: this.$store.state.currentProjectId,
        keywords: this.filters.keywords,
        startDate: new Date(new Date(new Date().toLocaleDateString()).getTime()),
        endDate: new Date(),
        status: this.filters.status,
        orderBy: {
          in_time: 'desc'
        },
        total: this.pagination.total,
        startNum: this.pagination.startNum,
        limit: this.pagination.limit
      }).then(result => {
        // console.log(result)
        this.tableInfos = Object.assign([], []);
        this.pagination.total = result.total;
        if(result.total > 0){
          result.rows.forEach((row, index) => {
            row.statusName = this.status[row.status];
            row.tagType = row.bindingType==3?"车":"人";
            row.tag = row.tagType + '：' + row.tagId;
          })
          this.tableInfos = result.rows;
        }
      }).catch(error => {
        console.error('查询进出人员异常', ApiApproach.searchInoutApi, error);
      })
    },
    /**
     * @Des 当前页数据改变
     * @Auth
     * @Date 2021/6/4
     */
    handleCurrentChangeSub(val){
      this.pagination.currentPage = val;
      this.pagination.startNum = this.pagination.limit * (val-1);
    },
    /**
     * @Des 页长度改变
     * @Auth
     * @Date 2021/6/4
     */
    handleSizeChangeSub(val){
      this.pagination.limit = val;
      this.pagination.currentPage = 1;
      this.pagination.startNum = 0;
    },
    /**
     * 是否选择
     * */
    checkSelectable(row){
      return true;
    },

  },


}
</script>

/* CSS */
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components_pages/Approach/ApproachToday.vue